import { useEffect } from 'react';
import { socket } from './socket';

export const useSocketHook = (isSocketConnected, socketListeners) => {
    
        console.log(socketListeners)
        console.log(isSocketConnected)

        if (!isSocketConnected) {
            console.log("Socket is disconnected, skipping listener attachment.");
            return;
        }
    
        console.log("Socket is connected, attaching listeners", socketListeners);
    
        socketListeners.forEach(({ socketlistener, callback }) => {
            console.log(`Attaching listener: ${socketlistener}`);
            socket.on(socketlistener, callback);
        });
    
 
};
